import React, { memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { useGetExperiencesList } from "@src/api/experiences-list/get-experiences-list";
import { useGetOrg } from "@src/api/organizations/get-organization";
import { TestIdeasAiButton } from "@src/components/Buttons/TestIdeasAiButton";
import { CheckoutScriptDialog } from "@src/components/Dialogs/CheckoutScriptDialog";
import { CreateExperimentDialog } from "@src/components/Dialogs/CreateExperimentDialog";
import { CreateShippingErrorDialog } from "@src/components/Dialogs/CreateShippingErrorDialog";
import { RedirectToPluginDialog } from "@src/components/Dialogs/RedirectToPluginDialog";
import { StartShippingErrorDialog } from "@src/components/Dialogs/StartShippingErrorDialog";
import { StartTestDialog } from "@src/components/Dialogs/StartTestDialog";
import { ThirdPartyCarrierWarningDialog } from "@src/components/Dialogs/ThirdPartyCarrierWarningDialog";
import { HistoryDrawer } from "@src/components/Drawer/HistoryDrawer";
import {
  checkAnyScope,
  checkBooleanScope,
} from "@src/components/LimitAccess/check-scopes";
import { ScopedButton } from "@src/components/LimitAccess/ScopedButton";
import Community from "@src/components/MainApp/Utils/Community";
import { Resources } from "@src/components/MainApp/Utils/Resources";
import { ScheduleExperienceDialog } from "@src/features/scheduleExperience/ScheduleExperienceDialog";
import { OfferLimitReachedDialog } from "@src/features/sharedExperience/components/alertsAndWarnings/OfferLimitReachedDialog";
import { useViewPage } from "@src/hooks/mixpanel";
import { useRouteTiming } from "@src/hooks/timing";
import { useWebsocket } from "@src/hooks/websocket";
import {
  selectedExperienceListFilters,
  setUseAppPadding,
} from "@src/store/slices/appSettings";
import { isDialogOpen, setDialog } from "@src/store/slices/global";
import { mpClickCreateExperienceButton } from "@src/utils/mixpanel";

import { ExperienceListHeader } from "./components/experiencesList/ExperienceListHeader";
import { ExperimentListTable } from "./components/experiencesList/ExperimentListTable";

export const ExperiencesHomeRoute = memo(function Experiments() {
  const organization = useGetOrg();
  const dispatch = useDispatch();
  useGetExperiencesList({ category: "experiment" });
  const scheduleDialogOpen = useSelector(isDialogOpen("scheduleTest"));

  const experienceListFilters = useSelector(selectedExperienceListFilters);

  const { lastJsonMessage } = useWebsocket();

  useEffect(() => {
    if (lastJsonMessage && lastJsonMessage.type === "productVariantStatus") {
      // setTestStatus((draft) => {
      //   if (!(lastJsonMessage.variantId in draft)) {
      //     draft[lastJsonMessage.variantId] = {};
      //   }
      //
      //   if (typeof lastJsonMessage.eventStatus === "string") {
      //     draft[lastJsonMessage.variantId][lastJsonMessage.testGroupId] =
      //       lastJsonMessage.eventStatus;
      //   }
      //   return draft;
      // });
    }
  }, [lastJsonMessage]);

  useViewPage("Home");

  useEffect(() => {
    dispatch(setUseAppPadding(true));
  }, []);

  useRouteTiming({
    page: "experiences",
    isReady: true,
  });

  return (
    <Grid container direction={"column"} rowSpacing={5}>
      <Grid
        item
        xs
        container
        direction={"row"}
        justifyContent={"space-between"}
        flexWrap={"nowrap"}
        alignItems={"center"}
      >
        <Grid container item>
          <Grid item>
            <IgTypography
              variant={"h1"}
              sx={{
                fontWeight: 600,
              }}
            >
              Tests
            </IgTypography>
          </Grid>
        </Grid>
        <Grid container item justifyContent={"end"} columnSpacing={2}>
          {/*<Grid item>*/}
          {/*  <TestIdeasAiButton />*/}
          {/*</Grid>*/}
          <Grid item>
            <ScopedButton
              sx={{ width: "170px" }}
              debugId={"create-new-exp-button"}
              onClick={() => {
                dispatch(setDialog({ dialog: "createExperiment", open: true }));
                mpClickCreateExperienceButton();
              }}
              isEnabled={checkAnyScope([
                checkBooleanScope(
                  "create_price_experiment",
                  organization.data.org.configurations
                ),
                checkBooleanScope(
                  "create_shipping_experiment",
                  organization.data.org.configurations
                ),
              ])}
            >
              Create New Test
            </ScopedButton>
          </Grid>
        </Grid>
      </Grid>
      {experienceListFilters && (
        <Grid item>
          <ExperienceListHeader />
        </Grid>
      )}
      <Grid item xs>
        <ExperimentListTable />
        <HistoryDrawer />
      </Grid>
      {/*<Grid item>*/}
      {/*  <ScreenshotRecommendationsPanel />*/}
      {/*</Grid>*/}
      <Grid item xs>
        <Community />
      </Grid>
      <Grid item xs>
        <Resources />
      </Grid>
      <CreateExperimentDialog />
      <CreateShippingErrorDialog />
      <StartShippingErrorDialog />
      <StartTestDialog />
      <CheckoutScriptDialog />
      <ThirdPartyCarrierWarningDialog />
      {scheduleDialogOpen && <ScheduleExperienceDialog />}
      <RedirectToPluginDialog
        type={"experiment"}
        isLoading={false}
        isEditorLaunch={false}
      />
      <OfferLimitReachedDialog />
    </Grid>
  );
});
